import { IconFunctionalSuccessCircle16, UIText2 } from '@cian/ui-kit';

import * as React from 'react';

import * as styles from './styles.css';

export const Notification: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <IconFunctionalSuccessCircle16 color="icon-positive-default" />
        <UIText2 color="white_100">Удалили сохранённый поиск</UIText2>
      </div>
    </div>
  );
};
